import { useMemo } from "react";
import { ConfigProvider, Tooltip } from "antd";
import dayjs from "dayjs";

import { useGetToken } from "@/shared/hooks/use-get-token";
import { UIFlatIcon } from "@/shared/ui/ui-flat-icon";

import { Timer } from "./timer";
import s from "./clock.module.scss";

const UTCTooltip = () => {
	const { token } = useGetToken();
	const { colorPrimaryText, colorPrimaryBg } = token;

	return (
		<ConfigProvider
			theme={{
				token: {
					colorTextLightSolid: colorPrimaryText,
					colorBgSpotlight: colorPrimaryBg,
					fontSize: 10,
				},
			}}
		>
			<Tooltip
				placement="bottom"
				title="All times displayed and stored on this platform are in UTC!"
			>
				<UIFlatIcon
					name="fi-rr-interrogation"
					tokenColor="colorIcon"
					size={14}
					className="hover:text-ant-color-info-active"
				/>
			</Tooltip>
		</ConfigProvider>
	);
};

export const Clock = () => {
	const utc = useMemo(() => `UTC${dayjs().format("Z").slice(0, 3).replace(/0/g, "")}`, []);

	return (
		<div data-testid="clock" className={s.clock}>
			<UIFlatIcon name="fi-rr-calendar-clock" tokenColor="colorIcon" />
			<p data-testid="value" className={s.value}>
				<Timer />
				<UTCTooltip />
				<span data-testid="utc" className={s.utc}>
					{utc}
				</span>
			</p>
		</div>
	);
};
